import { delay, startObservingDomMutations } from '../utility';
import { createPopper } from '@popperjs/core';

export default {
    data() {
        return {
            componentEnabled: false,
            menuShown: false,
            popperInstance: null,
            stopObservingDomMutations: () => null,
            resizeObserver: undefined,
        };
    },
    async mounted() {
        // await nextTick so portal can mount
        await this.$nextTick();
        //console.log('this.$refs.anchor', this.$refs.anchor)

        this.componentEnabled = true;

        this.stopObservingDomMutations = startObservingDomMutations(this.getVMenuEl(), {
            onAdded: (menuContainer) => {
                //console.log(`onAdded`, menuContainer);
                this.stopObservingDomMutations();
                this.stopObservingDomMutations = startObservingDomMutations(menuContainer, {
                    onStyleChange: () => {
                        //console.log(`onStyleChange`, menuContainer, menuContainer.style.display)
                        this.menuShown = menuContainer.style.display !== 'none';
                    }
                });
            }
        });
    },
    beforeDestroy() {
        if (this.stopObservingDomMutations) this.stopObservingDomMutations();
        if (this.resizeObserver) this.resizeObserver.disconnect();
    },
    watch: {
        async menuShown(val) {
            //console.log('menuShown', val);
            if (this.popperInstance) this.popperInstance.destroy();
            if (!val) {
                if (this.resizeObserver) this.resizeObserver.disconnect();
                return;
            }

            await this.$nextTick();

            //console.log('this.getReferenceEl()', this.getReferenceEl());
            //console.log('this.getPopperEl()', this.getPopperEl());

            const modifiers = [/*hide, */ /*minWidth,*/  {
                name: 'flip'
            }, {
                name: 'preventOverflow',
                options: {
                    padding: 8
                }
            }];

            if (this.popperOffset) {
                modifiers.push({
                    name: 'offset',
                    options: {
                        offset: this.popperOffset
                    }
                });
            }

            this.popperInstance = createPopper(this.getReferenceEl(), this.getPopperEl(), {
                placement: 'bottom-start',
                modifiers: modifiers
            });

            // Sometimes the inputs change width when they receive focus, this is
            // so the menu is still positioned correctly after the content jumps around.
            await delay(1);
            if (this.popperInstance) this.popperInstance.update();

            const resizeObserver = new ResizeObserver(this.popperInstance.update);

            resizeObserver.observe(this.getPopperEl());
            this.resizeObserver = resizeObserver;

        }
    }
};
